import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type NotificationType = {
  chamadoId?: string;
  conjuntoNome: string;
  empresa: string;
  grupos: string[];
  id: string;
  link: string;
  localNome: string;
  mensagem: string;
  nomeForm: string;
  nomeNotif: string;
  timestamp: number;
  timestampForm: string;
  tipo: string;
  unidadeNome: string;
  userOrigem: string;
  lido: boolean;
  lidoEm: number;
  nome: string;
};

export default class Notifications {


  getByUser = async (
    body: AuthBodyType
  ) => {
    try {
      const data: AxiosResponse = await api.post("/notificacoes/getByUser", {
        ...body,
      });
      return data.data.notificacoes;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  updateRead = async (
    body: AuthBodyType & { notif: string; date: number; user: string }
  ) => {
    try {
      const data: AxiosResponse = await api.post("/notificacoes/marcaLida", {
        ...body,
      });
      return data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  getConfigsByEmpresa = async (
    body: AuthBodyType
  ) => {
    try {
      const data: AxiosResponse = await api.post("/notificacoes/getConfigsByEmpresa", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  deleteConfig = async (
    body: AuthBodyType,
    id: string
  ) => {
    try {
      const data: AxiosResponse = await api.post("/notificacoes/deleteConfig", {
        ...body,
        id
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  limpaRepetidas = async (
    body: AuthBodyType,
    identifier: string
  ) => {
    try {
      const data: AxiosResponse = await api.post("/notificacoes/limpaRepetidas", {
        ...body,
        identifier
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };
}
